import Vue from 'vue'

Vue.filter('currency', (value, decimals) => {
  if (isNaN(Number(value))) return value

  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: decimals || 0,
  })
  return formatter.format(Number(value))
})
